import { Component, ElementRef, Injector, OnInit } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { FilterDropdownComponent } from '../../../../Common/Filter/components/filterDropdown/filter-dropdown.component';
import { FullProfileAnimationModel } from '../../../../Core/Dialogs/models/full-profile-animation.model';
import { FullProfileDialogAnimationsEnum } from '../../../../Core/Dialogs/enums/full-profile-dialog-animations.enum';
import { OverlayAnimationStateEnum } from '../../../../Core/Dialogs/enums/overlay-animation.enum';
import { FilterWidgetComponent } from '../../../../Common/Filter/components/FilterWidget/filter-widget.component';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { FilterService } from '../../../../Common/Filter/services/abstract-filter.service';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';
import { AgprComponentStyleEnum } from '../../../../Common/Basic/enums/social-analysis-types.enum';

@Component({
    selector: 'agpr-social-filter-input',
    templateUrl: '../../../../Common/Filter/components/filterDropdown/filter-dropdown.component.html',
    styleUrls: ['../../../../Common/Filter/components/filterDropdown/filter-dropdown.component.scss', './social-filter-input.component.scss'],
    standalone: false
})
export class SocialFilterInputComponent extends FilterDropdownComponent implements OnInit {
    overlayContainer: Element;

    constructor(
        protected injector: Injector,
        protected coreDialogService: CoreDialogService,
        protected filterService: FilterService,
        protected localizationService: LocalizationService,
        protected ref: ElementRef
    ) {
        super(injector, coreDialogService, filterService, localizationService, ref);
    }

    ngOnInit() {
        super.ngOnInit();
        if (this.ref.nativeElement.closest('.agpr-takeOverPanel-container')) {
            this.overlayContainer = this.ref.nativeElement.closest('.agpr-takeOverPanel-container');
        } else {
            this.overlayContainer = document.getElementById('main-content');
        }
    }

    open() {
        const animationTrigger = new BehaviorSubject(
            new FullProfileAnimationModel(
                FullProfileDialogAnimationsEnum.slideInOutAnimation,
                OverlayAnimationStateEnum.open
            )
        );

        const io = {
            inputs: {
                animationTrigger: animationTrigger,
                overlayContainer: this.overlayContainer,
                style: AgprComponentStyleEnum.social
            },
            outputs: {}
        };
        this.coreDialogService.open(FilterWidgetComponent, io, this.injector);
    }
}
